import { IndexPageConfig } from './index-page.model';

export const MOCK_INDEX_PAGE_CONFIG: IndexPageConfig = {
  header: {
    title: 'Broker Medicare Index',
    portals: [
      {
        label: 'Employer Portal',
        route: '/employer-portal',
      },
      {
        label: 'Internal Admin Portal',
        route: '/admin-portal',
      },
    ],
  },
  columns: [
    {
      cards: [
        {
          groups: [
            {
              label: 'Workbench',
              views: [
                {
                  label: 'Overview',
                  route: '/workbench',
                  actions: null,
                },
              ],
            },
          ],
        },
        {
          groups: [
            {
              label: 'Applications',
              views: [
                {
                  label: 'Application List',
                  route: '/applications',
                  actions: [
                    {
                      label: 'New Application',
                      key: 'new_application',
                    },
                  ],
                },
              ],
            },
            {
              label: 'Application Details',
              views: [
                {
                  label: 'Profile',
                  route: '/profile',
                  actions: null,
                },
                {
                  label: 'Census',
                  route: '/census',
                  actions: null,
                },
                {
                  label: 'Plans',
                  route: '/plans',
                  actions: null,
                },
                {
                  label: 'Individual Rate',
                  route: '/individual-rate',
                  actions: null,
                },
                {
                  label: 'Documents',
                  route: '/documents',
                  actions: null,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      cards: [
        {
          groups: [
            {
              label: 'Groups',
              views: [
                {
                  label: 'Group List',
                  route: '/groups',
                  actions: null,
                },
              ],
            },
            {
              label: 'Group Details',
              views: [
                {
                  label: 'Overview',
                  route: '/group-details',
                  actions: [
                    {
                      label: 'Upsell Quoting',
                      key: 'upsell_quoting',
                    },
                  ],
                },
                {
                  label: 'Employees',
                  route: '/employees',
                  actions: [
                    {
                      label: 'Upsell Enrollment',
                      key: 'upsell_enrollment',
                    },
                  ],
                },
                {
                  label: 'Maintenance',
                  route: '/maintenance',
                  actions: null,
                },
                {
                  label: 'Policies',
                  route: '/policies',
                  actions: null,
                },
                {
                  label: 'Applications',
                  route: '/applications',
                  actions: null,
                },
                {
                  label: 'Quotes',
                  route: '/quotes',
                  actions: null,
                },
                {
                  label: 'Billing',
                  route: '/billing',
                  actions: null,
                },
              ],
            },
            {
              label: 'Prospects',
              views: [
                {
                  label: 'Prospect Details',
                  route: '/prospect-details',
                  actions: [
                    {
                      label: 'New Prospect',
                      key: 'new_prospect',
                    },
                  ],
                },
              ],
            },
            {
              label: 'Group Billing',
              views: [
                {
                  label: 'Invoices',
                  route: '/invoices',
                  actions: [
                    {
                      label: 'Make a Payment',
                      key: 'make_payment',
                    },
                  ],
                },
                {
                  label: 'Payments',
                  route: '/payments',
                  actions: null,
                },
                {
                  label: 'AutoPay',
                  route: '/autopay',
                  actions: null,
                },
                {
                  label: 'Payment Methods',
                  route: '/methods',
                  actions: null,
                },
              ],
            },
            {
              label: 'Subgroup Details',
              views: [
                {
                  label: 'Subgroup Details',
                  route: '/subgroup-details',
                  actions: [
                    {
                      label: 'New Group Contact',
                      key: 'new_group_contact',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          groups: [
            {
              label: 'Billing',
              views: [
                {
                  label: 'Billing List',
                  route: '/bills',
                  actions: null,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      cards: [
        {
          groups: [
            {
              label: 'Quotes',
              views: [
                {
                  label: 'Quote List',
                  route: '/quotes',
                  actions: [
                    {
                      label: 'New Quote',
                      key: 'new_quote',
                    },
                    {
                      label: 'Request for Quote',
                      key: 'request_quote',
                    },
                  ],
                },
              ],
            },
            {
              label: 'Quote Details',
              views: [
                {
                  label: 'New Business',
                  route: '/quotes/new-business',
                  actions: [
                    {
                      label: 'Create Alternate',
                      key: 'create_alternate',
                    },
                  ],
                },
                {
                  label: 'Renewal Quote',
                  route: '/quotes/renewal',
                  actions: [
                    {
                      label: 'Renewal Enrollment',
                      key: 'renewal_enrollment',
                    },
                  ],
                },
                {
                  label: 'Alternate Quote',
                  route: '/quotes/alternate',
                  actions: null,
                },
              ],
            },
          ],
        },
        {
          groups: [
            {
              label: 'Policies',
              views: [
                {
                  label: 'Policy List',
                  route: '/policies',
                  actions: null,
                },
              ],
            },
            {
              label: 'Policy Details',
              views: [
                {
                  label: 'Plan Information',
                  route: '/plan-information',
                  actions: null,
                },
                {
                  label: 'Benefits',
                  route: '/benefits',
                  actions: null,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
